<template>
  <div class="c-statusChart">
    <h2 class="c-statusChart_title">COTAÇÕES POR STATUS</h2>
    <div class="c-statusChart_body">
      <div class="c-statusChart_chartWrap">
        <chartEmptyState color="#F6F6F6" :diameter="160/2" :thickness="160/2" v-if="isEmptyChart"/>

        <Doughnut v-else
          id="status"
          :chart-options="chartOptions"
          :chart-data="chartData"
          :width="160"
          :height="160"
        />
        <div class="c-statusChart_info">
          <h3 class="c-statusChart_infoTitle">{{ sumDate }}</h3>
          <h4 class="c-statusChart_infoSubTitle">COTAÇÕES</h4>

        </div>
      </div>
      <div class="c-statusChart_labelWrap">
        <div class="c-statusChart_label">
          <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'c-statusChart_labelIcon--yellow'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M14 .147a.043.043 0 00-.021-.04.043.043 0 00-.045 0L5.203 5.182a.118.118 0 01-.122 0L.066 2.326a.043.043 0 00-.066.04v3.588a.043.043 0 00.023.039l5.058 2.89a.118.118 0 00.122 0l8.729-5.049a.126.126 0 00.062-.105L14 .147z" fill="currentColor"/></svg>
          Em andamento
        </div>
        <div class="c-statusChart_label">
          <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'c-statusChart_labelIcon--purple'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M14 .147a.043.043 0 00-.021-.04.043.043 0 00-.045 0L5.203 5.182a.118.118 0 01-.122 0L.066 2.326a.043.043 0 00-.066.04v3.588a.043.043 0 00.023.039l5.058 2.89a.118.118 0 00.122 0l8.729-5.049a.126.126 0 00.062-.105L14 .147z" fill="currentColor"/></svg>

          Em negociação
        </div>
        <div class="c-statusChart_label">
          <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'c-statusChart_labelIcon--blue'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M14 .147a.043.043 0 00-.021-.04.043.043 0 00-.045 0L5.203 5.182a.118.118 0 01-.122 0L.066 2.326a.043.043 0 00-.066.04v3.588a.043.043 0 00.023.039l5.058 2.89a.118.118 0 00.122 0l8.729-5.049a.126.126 0 00.062-.105L14 .147z" fill="currentColor"/></svg>
          Concluída
        </div>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import Vue, { PropOptions } from 'vue'
import { mapState, mapActions } from 'vuex'
import { StoreState } from 'Types'
import { Doughnut } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'
const chartEmptyState = () => import('Components/CompanyAccount/Dashboard/Cards/chartEmptyState')

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)


const initialState = () => ({
  chartData: {
    labels: [ 'Em andamento', 'Em negociação', 'Concluída'],
    datasets: [ {
      backgroundColor: ['#FFC445', '#A666B5', '#2BA3D9',],
      data: []
    } ]
  },
  chartOptions: {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
         display: false
      },
      emptyDoughnut: {
        color: 'rgba(255, 128, 0, 0.5)',
        width: 2,
        radiusDecrease: 20
      }
    }
  },
})


export default Vue.extend({
  props: {
    requestPath: { required: false, type: String, default: '' } as PropOptions<string>,
  },

  data() {
    return initialState()
  },

  components: {
    Doughnut,
    chartEmptyState
  },

  created() {
    this.getQuoteStatusDashboard(this.requestPath)
    // this.isMobile = window.matchMedia('(max-width: 768px)').matches
  },

  computed: {
    ...mapState({
      quoteStatusDashboard: state => state.quoteRequest.quoteStatusDashboard,
    }),

    isEmptyChart() {
      return (
        this.quoteStatusDashboard.inProgress === 0 &&
        this.quoteStatusDashboard.inNegociation === 0 &&
        this.quoteStatusDashboard.approved === 0
      )
    },

    statusData() {
      return [
        this.quoteStatusDashboard.inProgress,
        this.quoteStatusDashboard.inNegociation,
        this.quoteStatusDashboard.approved,
      ];
    },

    sumDate() {
      return (
        this.quoteStatusDashboard.inProgress +
        this.quoteStatusDashboard.inNegociation +
        this.quoteStatusDashboard.approved
      )
    }
  },

  methods: {
    ...mapActions({
      getQuoteStatusDashboard: 'quoteRequest/getQuoteStatusDashboard'
    }),
  },

  watch: {
    statusData: {
      handler(newData) {
        this.chartData.datasets[0].data = newData;

      },
      immediate: true
    }
  }
})
</script>

<style lang="scss">
@import "~css/_references";

.c-statusChart {
  background-color: $v-colorWhite;
  padding: 24px;
  box-shadow: 4px 4px 25px #B1B1B140;
  border-radius: 8px;

  &_title {
    @include f-fontBrand(18px);
    padding-left: 12px;
    border-left: 2px solid #D3EBE8;
    flex-direction: row;
    margin-bottom: 24px;
  }

  &_chartWrap {
    display: grid;
    gap: 36px;
    grid-template-columns: 160px auto;
  }

  &_info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &_infoTitle {
    @include f-fontBrand (48px);
    font-weight: 600;
  }

  &_infoSubTitle {
    @include f-fontSystem (16px, #6D6A6E);
    font-weight: 400;
  }

  &_labelWrap {
    @include f-fontSystem (14px);
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 16px;
    margin-top: 16px;
  }

  &_labelIcon {
    height: 14px;
    width: 14px;
    margin-right: 8px;

    &--yellow {
      color: $v-colorYellow;
    }

    &--blue {
      color: $v-colorBlue-3;
    }

    &--purple {
      color: $v-colorPurple-2;
    }
  }

}
</style>